import { LucideProps } from "lucide-react";

function UserIcon(props: LucideProps) {
  return (
    <svg
      width="96"
      height="96"
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_10721_89418)">
        <rect
          x="0.796875"
          y="0.344238"
          width="95.2056"
          height="95.655"
          rx="47.6028"
          fill="url(#paint0_linear_10721_89418)"
        />
        <rect
          x="0.796875"
          y="0.345703"
          width="95.2056"
          height="95.655"
          rx="47.6028"
          fill="url(#paint1_radial_10721_89418)"
        />
        <g style={{ mixBlendMode: "darken" }} opacity="0.4">
          <path
            d="M52.924 55.554C64.1575 55.554 73.264 46.4475 73.264 35.214C73.264 23.9806 64.1575 14.874 52.924 14.874C41.6905 14.874 32.584 23.9806 32.584 35.214C32.584 46.4475 41.6905 55.554 52.924 55.554Z"
            fill="url(#paint2_radial_10721_89418)"
          />
        </g>
        <path
          d="M47.764 45.234C56.1477 45.234 62.944 38.4377 62.944 30.054C62.944 21.6703 56.1477 14.874 47.764 14.874C39.3803 14.874 32.584 21.6703 32.584 30.054C32.584 38.4377 39.3803 45.234 47.764 45.234Z"
          fill="white"
        />
        <g style={{ mixBlendMode: "darken" }} opacity="0.4">
          <path
            d="M53.5003 96.0001C71.4109 96.0001 85.9303 86.8348 85.9303 75.5289C85.9303 64.2229 71.4109 55.0576 53.5003 55.0576C35.5897 55.0576 21.0703 64.2229 21.0703 75.5289C21.0703 86.8348 35.5897 96.0001 53.5003 96.0001Z"
            fill="url(#paint3_radial_10721_89418)"
          />
        </g>
        <path
          d="M73.7812 68.9115C73.7812 77.0715 59.6404 83.9629 47.76 83.9629C35.8796 83.9629 22.2188 76.231 22.2188 68.9115L22.23 66.796C22.5506 60.5354 27.5681 53.8185 34.9331 50.8335C35.8238 50.4716 36.825 50.5298 37.6913 50.9479C40.7363 52.4179 44.1525 53.2429 47.76 53.2429C51.4406 53.2429 54.9225 52.3841 58.0144 50.8579C58.875 50.4323 59.8744 50.3666 60.7688 50.7191C68.295 53.6798 73.4456 60.4641 73.7681 66.8091L73.7812 68.9115Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_10721_89418"
          x1="11.5892"
          y1="11.1875"
          x2="85.2154"
          y2="84.4678"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D8DBDF" />
          <stop offset="0.3342" stopColor="#CACED3" />
          <stop offset="0.7653" stopColor="#B9BFC6" />
          <stop offset="1" stopColor="#B3BAC1" />
        </linearGradient>
        <radialGradient
          id="paint1_radial_10721_89418"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(7.68316 8.76915) scale(59.5355 59.8166)"
        >
          <stop stopColor="#DDE0E4" />
          <stop offset="1" stopColor="#DDE0E4" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_10721_89418"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(52.485 36.2333) scale(17.8909)"
        >
          <stop stopColor="#515151" />
          <stop offset="0.1716" stopColor="#575757" stopOpacity="0.828" />
          <stop offset="0.4187" stopColor="#666666" stopOpacity="0.581" />
          <stop offset="0.7098" stopColor="#808080" stopOpacity="0.29" />
          <stop offset="1" stopColor="#A0A0A0" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_10721_89418"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(53.3503 75.1379) scale(31.1692 19.6743)"
        >
          <stop stopColor="#515151" />
          <stop offset="0.1715" stopColor="#575757" stopOpacity="0.829" />
          <stop offset="0.4284" stopColor="#686868" stopOpacity="0.572" />
          <stop offset="0.7371" stopColor="#838383" stopOpacity="0.263" />
          <stop offset="1" stopColor="#A0A0A0" stopOpacity="0" />
        </radialGradient>
        <clipPath id="clip0_10721_89418">
          <rect width="96" height="96" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default UserIcon;
